<div class="px-3 pt-3">
  <app-filter-card
    [hidden]="hideFilterCard"
    (onApply)="filterCardData$.next($event)"
    [filterNames]="['dashboard', 'form']"
  ></app-filter-card>
  <mat-card appearance="outlined">
    <mat-card-content class="p-0">
      <app-datatable
        [configurationInput]="datatableConfigurations"
        [rowData]="store.data$()"
        [columns]="datatableColumns"
        [total]="this.store.dataTotal$()"
        [customColumnDef]="[
          { name: 'dashboard', template: dashboardCell, isSortable: true },
          { name: 'form', template: formCell, isSortable: true },
          { name: 'formAssociation', template: formAssociation, isSortable: false },
          { name: 'submittedBy', template: assigneeCell, isSortable: true },
          { name: 'actions', template: actionCell, isSortable: false },
          { name: 'submittedAt', template: dateCell, isSortable: true },
        ]"
        (dataRefreshRequest)="datatableParams$.next($event)"
        (selectedItemsChange)="selectedDatatableItems.set($event)"
      />
    </mat-card-content>
  </mat-card>
</div>

<ng-template #dashboardCell let-row="row">
  <div class="white-space-nowrap">
    {{ row.dashboard }}
    <mat-chip *ngIf="row.isDashboardDeleted" class="chip-hover-remove" [disableRipple]="true">
      {{ 'field.deleted' | translate | uppercase }}</mat-chip
    >
  </div>
</ng-template>

<ng-template #formCell let-row="row">
  <div class="white-space-nowrap">
    {{ row.form }}
    <mat-chip *ngIf="row.isFormDeleted" class="chip-hover-remove" [disableRipple]="true">
      {{ 'field.deleted' | translate | uppercase }}</mat-chip
    >
  </div>
</ng-template>

<ng-template #dateCell let-row="row">
  {{ row.submittedAt | utcToUserFormatted: true }}
</ng-template>

<ng-template #assigneeCell let-row="row">
  <app-user-chip [name]="row.submittedBy"></app-user-chip>
</ng-template>

<ng-template #actionCell let-row="row">
  <button mat-stroked-button color="primary" (click)="onView(row)">
    {{ 'button.view' | translate }}
  </button>
</ng-template>

<ng-template #formAssociation let-row="row">
  <div class="d-block text-pre-line form-association">
    {{ row.formAssociation }}
  </div>
</ng-template>
